module.exports = __webpack_public_path__ + "node_modules/@aetonix/assets/src/images/IconBlue.png";